export default "__VITE_ASSET__BjbbKfin__"